import React from "react";
import "../App.css";
import "../sections/Contact.css";

const Contact = () => (
  <section id="contact" className="contact-section">
   <h2 className="contact-heading">
        Bringing your ideas to life. <br />
        <span>Let's turn your vision into reality</span>
      </h2>
      <p className="contact-subtext">
        Have a project in mind or just want to chat? Let's connect!
      </p>

      <form
        className="contact-form"
        action="https://formspree.io/f/xzbodakl"
        method="POST"
      >
        <label>
          Name
          <input type="text" name="name" placeholder="Your Name" required />
        </label>

        <label>
          Email
          <input type="email" name="email" placeholder="contact@example.com" required />
        </label>

        <label>
          Message
          <textarea name="message" placeholder="Your message here..." rows="5" required />
        </label>

        <button type="submit">Send</button>
      </form>
  </section>
);

export default Contact;
